var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gekko-logo-anim"},[_c('span',{staticClass:"sr-only"},[_vm._v("Gekko")]),_c('lottie',{class:_vm.color,attrs:{"options":_vm.animationOptions},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }